import CustomLoader from './customLoader';

export default CustomLoader;